import { css } from 'styled-components'

export const Fonts = css`
  @font-face {
    font-family: 'Noto Sans KR';
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/NotoSansKR-Bold.woff') format('woff');
  }

  @font-face {
    font-family: 'Noto Sans KR';
    font-weight: 500;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/NotoSansKR-Medium.woff') format('woff');
  }

  @font-face {
    font-family: 'Noto Sans KR';
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/NotoSansKR-Regular.woff') format('woff');
  }

  @font-face {
    font-family: 'NanumSquareEB';
    font-weight: 800;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/NanumSquareEB.woff') format('woff');
  }

  @font-face {
    font-family: 'NanumSquareB';
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/NanumSquareB.woff') format('woff');
  }

  @font-face {
    font-family: 'NanumSquareR';
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/NanumSquareR.woff') format('woff');
  }
`
